import React, { useState } from "react";
import toast from "react-hot-toast";
import { useLocation, useParams } from "react-router";
import { FormatDateTime } from "../../../../../utils/functions/ResourceFunctions";
import { useGetFloatRequestByIdQuery } from "../../../../api/employeeFloat";
import {
  useGetRetirementByIdQuery,
  useSubmitRetirementMutation,
} from "../../../../api/financeApi";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import { CTAButtons } from "../../../../global/components/Buttons/buttons";
import PageLayout from "../../../Components/Layout/PageLayout";
import { AppModalTemplate } from "../../../Components/Modals/Modals";
import RetirementFormModal from "./modals/RetirementFormModal";
import { SurveyModal } from "./modals/SurveyModal";
import Table from "../../../Components/Table/Table";
import { TableActionsDownload } from "../../../Components/Misc/Actions";
const ViewRetirement = () => {
  const { id } = useParams();
  const location = useLocation()?.state;
  const [vendorDocument, setVendorDocument] = useState(
    location?.documents || [],
  );
  const [openRetireModal, setOpenRetireModal] = useState();
  const { data } = useGetFloatRequestByIdQuery(id);
  const { data: retirementData } = useGetRetirementByIdQuery(id);
  const [openSurveyModal, setOpenSurveyModal] = useState();
  const handleOpenRetireModal = () => setOpenRetireModal(!openRetireModal);
  const handleOpenSurveyModal = () => {
    setOpenSurveyModal(!openSurveyModal);
    setOpenRetireModal(false);
  };
  const [submitRetirement, { isLoading }] = useSubmitRetirementMutation();
  const floatList = [
    {
      label: "Float Advance",
      value: 0,
    },
    {
      label: "Promotional Items",
      value: 1,
    },
    { label: "Perishables", value: 2 },
    {
      label: "Visitation",
      value: 3,
    },
  ];
  const handleSubmitSurvey = async (formData, surveyData, retirementData) => {
    try {
      const submissionData = new FormData();
      const surveyQuestions =
        surveyData?.questions || surveyData?.result?.questions || [];

      // Add basic fields
      submissionData.append("FloatRequestId", id);
      submissionData.append(
        "Components",
        JSON.stringify(
          data?.responseObject?.floatAdvance?.components?.map((item) => {
            return {
              componentName: item?.componentName,
              approvedAmount: item?.amount,
              actualAmount: 0,
              displayOrder: 0,
            };
          }),
        ),
      );
      submissionData.append("OutcomeReport", "hello");

      // Add survey responses from form data
      const surveyResponses = [];

      // First, collect all checkbox responses for multi-select questions
      const checkboxGroups = {};
      Object.keys(formData).forEach((key) => {
        if (key.startsWith("question_") && key.includes("_")) {
          const parts = key.split("_");
          const questionId = parseInt(parts[1]);
          const optionId = parts[2];

          if (optionId && formData[key]) {
            if (!checkboxGroups[questionId]) {
              checkboxGroups[questionId] = [];
            }
            checkboxGroups[questionId].push(optionId);
          }
        }
      });

      // Process all questions, including those with checkbox groups
      const processedQuestions = new Set();

      // First process checkbox questions
      Object.keys(checkboxGroups).forEach((questionId) => {
        processedQuestions.add(parseInt(questionId));
        const question = surveyQuestions.find(
          (q) => q.id === parseInt(questionId),
        );

        if (question && question.questionType === 1) {
          let responseValue = checkboxGroups[questionId];

          // Convert to displayOrder format
          const displayOrders = responseValue.map((val) => {
            const option = question.options.find(
              (opt) => opt.id === parseInt(val),
            );
            return option ? option.displayOrder.toString() : val;
          });

          responseValue = {
            ids: responseValue.join(","), // Original option IDs
            displayOrders: displayOrders.join(","), // DisplayOrder values
          };

          let responseObj = {
            surveyQuestionId: parseInt(questionId),
            responseText: responseValue.displayOrders,
            numericResponse: 0,
            selectedOptionIds: responseValue.ids,
            selectedOptionId: 0,
          };

          surveyResponses.push(responseObj);
        }
      });

      // Then process other question types (non-checkbox)
      surveyQuestions.forEach((question) => {
        const questionId = question.id;

        // Skip if already processed as checkbox
        if (processedQuestions.has(questionId)) {
          return;
        }

        let responseValue = formData[`question_${questionId}`];

        if (responseValue === undefined) {
          return; // Skip if no response for this question
        }

        // Handle multi-select arrays - convert to comma-separated string of displayOrders
        if (Array.isArray(responseValue)) {
          const questionData = surveyQuestions.find((q) => q.id === questionId);
          if (questionData && questionData.questionType === 1) {
            const displayOrders = responseValue.map((val) => {
              const option = questionData.options.find(
                (opt) => opt.id === parseInt(val),
              );
              return option ? option.displayOrder.toString() : val;
            });
            // Store displayOrders in responseText, keep original IDs in responseValue
            responseValue = {
              ids: responseValue.join(","), // Original option IDs
              displayOrders: displayOrders.join(","), // DisplayOrder values
            };
          }
        }

        let responseObj = {
          surveyQuestionId: questionId,
          responseText: "",
          numericResponse: 0,
          selectedOptionIds: "",
          selectedOptionId: 0,
        };

        if (question) {
          switch (question.questionType) {
            case 1: // Checkbox - multiple selections (should be handled above)
              if (typeof responseValue === "object" && responseValue.ids) {
                // Multi-select with both IDs and displayOrders
                responseObj.selectedOptionIds = responseValue.ids;
                responseObj.responseText = responseValue.displayOrders;
              } else if (responseValue) {
                // Single selection - get displayOrder for responseText and ID for selectedOptionIds
                const option = question.options.find(
                  (opt) => opt.id === parseInt(responseValue),
                );
                responseObj.selectedOptionIds = responseValue.toString();
                responseObj.responseText = option
                  ? option.displayOrder.toString()
                  : responseValue.toString();
              }
              break;
            case 2: // Radio - single selection
              // For radio, get displayOrder for responseText and ID for selectedOptionId
              const radioOption = question.options.find(
                (opt) => opt.id === parseInt(responseValue),
              );
              responseObj.selectedOptionId = parseInt(responseValue) || 0;
              responseObj.responseText = radioOption
                ? radioOption.displayOrder.toString()
                : responseValue.toString();
              break;
            case 3: // Rating - numeric response
              // For rating, use the displayOrder value directly
              responseObj.numericResponse = parseInt(responseValue) || 0;
              responseObj.responseText = responseValue.toString();
              break;
            case 4: // Text
            case 5: // Textarea
              responseObj.responseText = responseValue || "";
              break;
            default:
              if (Array.isArray(responseValue)) {
                responseObj.selectedOptionIds = responseValue.join(",");
              }
          }
        } else {
          // Fallback: determine response type based on value format
          if (typeof responseValue === "string") {
            if (responseValue.includes(",")) {
              responseObj.selectedOptionIds = responseValue;
            } else if (!isNaN(responseValue) && responseValue !== "") {
              const numValue = parseInt(responseValue);
              if (numValue > 0) {
                responseObj.selectedOptionId = numValue;
              } else {
                responseObj.responseText = responseValue;
              }
            } else {
              responseObj.responseText = responseValue;
            }
          } else if (typeof responseValue === "number") {
            responseObj.numericResponse = responseValue;
          } else if (Array.isArray(responseValue)) {
            responseObj.selectedOptionIds = responseValue.join(",");
          }
        }

        surveyResponses.push(responseObj);
      });

      submissionData.append("SurveyResponses", JSON.stringify(surveyResponses));

      // Handle documents from retirement data
      const documents = retirementData?.result?.documents || [];
      documents.forEach((doc, index) => {
        if (doc.file) {
          submissionData.append(`Documents[${index}].file`, doc.file);
          submissionData.append(
            `Documents[${index}].fileName`,
            doc.fileName || doc.file?.name,
          );
        } else if (doc.filePath) {
          // For existing documents, just append the file info
          submissionData.append(`Documents[${index}].fileName`, doc.fileName);
          submissionData.append(`Documents[${index}].filePath`, doc.filePath);
        }
      });

      // Also handle vendorDocument if it exists
      vendorDocument.forEach((doc, index) => {
        if (doc.file) {
          submissionData.append(
            `Documents[${documents.length + index}].file`,
            doc.file,
          );
          submissionData.append(
            `Documents[${documents.length + index}].fileName`,
            doc.fileName,
          );
        }
      });
      const promotionalItems = Array.isArray(
        data?.responseObject?.promotionalItems?.items,
      )
        ? data?.responseObject?.promotionalItems?.items?.map((item) => ({
            itemName: item?.itemName,
            itemCategory: data?.responseObject?.promotionalItems?.itemCategory,
            vendor: item?.vendor,
            amount: item?.amount,
            deliveryDate: item?.deliveryDate,
            displayOrder: item?.displayOrder,
          }))
        : [];
      submissionData.append(
        "PromotionalItems",
        JSON.stringify(promotionalItems),
      );
      const response = await submitRetirement(submissionData).unwrap();
      if (response?.successful) {
        toast.success(response?.statusMessage);
        handleOpenSurveyModal();
      }
    } catch (error) {
      toast.error(error?.data?.statusMessage);
      console.log(error);
    }
  };
  const actionButton = (
    <div>
      {data?.responseObject?.floatAdvance?.components?.length > 0 ? (
        <CTAButtons hideIcon onClick={handleOpenRetireModal}>
          Retire
        </CTAButtons>
      ) : (
        <CTAButtons hideIcon onClick={handleOpenSurveyModal}>
          Survey
        </CTAButtons>
      )}
    </div>
  );
  const purposes = [
    { label: "Business Development", value: 0 },
    { label: "Relationship Management", value: 1 },
  ];
  const requestForOptions = [
    { label: "Self", value: 0 },
    { label: "Team", value: 1 },
  ];
  const categoryType = data?.responseObject?.purpose === 0 ? 1 : 2;
  return (
    <PageLayout
      title={"Float Review Details"}
      hasBack={true}
      action={actionButton}
    >
      <div className={DashboardStyle.view_app_components}>
        <section
          style={{
            backgroundColor: "#F8FBF8",
            border: "1px solid #D9E9DA",
            borderRadius: "8px",
          }}
          className={DashboardStyle.form_section}
        >
          <h4 className={DashboardStyle.form_section_title}>
            Process Information
          </h4>
          <div className={DashboardStyle.labels_group}>
            <div>
              <div>
                <p>Process Type:</p>
                <h4>Float Retirement</h4>
              </div>
              <div>
                <p>Date Requested:</p>
                <h4>{FormatDateTime(data?.responseObject?.requestDate)}</h4>
              </div>
              <div>
                <p>Approval Status:</p>
                <h4>{data?.responseObject?.approvalResponse?.status}</h4>
              </div>
            </div>
            <div>
              <div>
                <p>Requested By:</p>
                <h4>{data?.responseObject?.requestorName}</h4>
              </div>
            </div>
          </div>
        </section>
        <section
          style={{
            backgroundColor: "#F8FBF8",
            border: "1px solid #D9E9DA",
            borderRadius: "8px",
          }}
          className={DashboardStyle.form_section}
        >
          <h4 className={DashboardStyle.form_section_title}>
            Request Information
          </h4>

          <div className={DashboardStyle.labels_group}>
            <div>
              <div>
                <p>Purpose:</p>
                <h4>
                  {
                    purposes.filter(
                      (item) => item.value === data?.responseObject?.purpose,
                    )[0]?.label
                  }
                </h4>
              </div>
              <div>
                <p>Reqest For:</p>
                <h4>
                  {
                    requestForOptions.filter(
                      (item) => item.value === data?.responseObject?.requestFor,
                    )[0]?.label
                  }
                </h4>
              </div>
            </div>
            <div>
              <div>
                <p>Effective Days:</p>
                {/* <h4>{request?.employeeGroup?.title}</h4> */}
              </div>
              <div>
                <p>Number Of Days:</p>
                {/* <h4>{FormatDateTime(employeecreatedDate, "ll")}</h4> */}
              </div>
              <div></div>
            </div>
          </div>
        </section>
        <section
          style={{
            backgroundColor: "#F8FBF8",
            border: "1px solid #D9E9DA",
            borderRadius: "8px",
          }}
          className={DashboardStyle.form_section}
        >
          <h4 className={DashboardStyle.form_section_title}>
            Float Information
          </h4>

          <div className={DashboardStyle.labels_group}>
            <div>
              <div>
                <p>Float Type:</p>
                <h4>
                  {floatList
                    .filter((item) =>
                      data?.responseObject?.floatTypes?.includes(item.value),
                    )
                    .map((item) => `${item.label},`)}
                </h4>
              </div>
            </div>
          </div>
        </section>
        {data?.responseObject?.floatAdvance?.components?.length > 0 && (
          <section className="p-4 grid grid-cols-2 gap-4">
            <div className="col-span-1">
              <h4 className={DashboardStyle.form_section_title}>
                Float Advance
              </h4>
            </div>

            <div className="w-full col-span-2">
              <div className={DashboardStyle.labels_group}>
                <div>
                  <div>
                    <p>Sub-Category:</p>
                    <h4>{data?.responseObject?.floatAdvance?.subcategory}</h4>
                  </div>
                  <div>
                    <p>Total Amount:</p>
                    <h4>{data?.responseObject?.floatAdvance?.totalAmount}</h4>
                  </div>
                </div>
                <div>
                  <div>
                    <p>Budget:</p>
                    {/* <h4>{request?.employeeGroup?.title}</h4> */}
                  </div>
                  <div>
                    <p>Budget Status:</p>
                    {/* <h4>{FormatDateTime(employeecreatedDate, "ll")}</h4> */}
                  </div>
                </div>
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium mb-2">
                  Components
                </label>
                <table className="w-full border">
                  <thead className="text-[#29382A] font-[500] bg-[#D9E9DA]">
                    <tr>
                      <th className="border p-2">S/N</th>
                      <th className="border p-2">Component</th>
                      <th className="border p-2">Optional</th>
                      <th className="border p-2">Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.responseObject?.floatAdvance?.components?.map(
                      (item, index) => {
                        return (
                          <tr className="text-[#4B664C] font-[500]" key={index}>
                            <td className="border p-2">{index + 1}</td>
                            <td className="border p-2">{item.componentName}</td>
                            <td className="border p-2">
                              {item.isCompulsory ? "Yes" : "No"}
                            </td>
                            <td className="border p-2">
                              <div className="border rounded flex items-center space-x-1 p-1 ">
                                <p>₦{item.amount}</p>
                              </div>
                            </td>
                          </tr>
                        );
                      },
                    )}
                  </tbody>
                </table>
              </div>
              <section>
                <div
                  className={` ${DashboardStyle.labels_group} ${DashboardStyle.labels_group_downloads} `}
                >
                  {retirementData?.result?.documents?.length === 0 ? (
                    <p>No Record Available</p>
                  ) : (
                    <Table>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>File Name</th>
                          <th>File Type</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {retirementData?.result?.documents?.map?.(
                          (x, index) => {
                            return (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{x?.fileName || x?.file?.name}</td>
                                <td style={{ textTransform: "uppercase" }}>
                                  {x?.file?.type?.split("/")?.[1] ||
                                    x?.fileName
                                      ?.split(".")
                                      ?.pop()
                                      ?.toUpperCase() ||
                                    "Unknown"}
                                </td>
                                <td>
                                  <TableActionsDownload
                                    file={x?.file || null}
                                    url={x?.fileUrl || null}
                                  />
                                </td>
                              </tr>
                            );
                          },
                        )}
                      </tbody>
                    </Table>
                  )}
                </div>
              </section>
            </div>
          </section>
        )}
        {data?.responseObject?.promotionalItems?.items?.length > 0 && (
          <section className="p-4 grid grid-cols-2 gap-4">
            <div className="col-span-1">
              <h4 className={DashboardStyle.form_section_title}>
                Promotional Item
              </h4>
            </div>

            <div className="w-full col-span-2">
              <div className={DashboardStyle.labels_group}>
                <div>
                  <div>
                    <p>Item Category:</p>
                    <h4>
                      {data?.responseObject?.promotionalItems?.itemCategory}
                    </h4>
                  </div>
                  <div>
                    <p>Budget:</p>
                    <h4>{data?.responseObject?.floatAdvance?.totalAmount}</h4>
                  </div>
                </div>
                <div>
                  <div>
                    <p>Budget Status:</p>
                    {/* <h4>{FormatDateTime(employeecreatedDate, "ll")}</h4> */}
                  </div>
                </div>
              </div>
              <div>
                <table className="w-full border">
                  <thead className="text-[#29382A] font-[500] bg-[#D9E9DA]">
                    <tr>
                      <th className="border p-2">S/N</th>
                      <th className="border p-2">Items</th>
                      <th className="border p-2">Stock Availability</th>
                      <th className="border p-2">Quantity Requested</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.responseObject?.promotionalItems?.items?.map(
                      (item, index) => {
                        return (
                          <tr className="text-[#4B664C] font-[500]" key={index}>
                            <td className="border p-2">{index + 1}</td>
                            <td className="border p-2">{item.itemName}</td>
                            <td className="border p-2">
                              {item.availableStock}
                            </td>
                            <td className="border p-2">{item.quantity}</td>
                          </tr>
                        );
                      },
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        )}
      </div>
      {openRetireModal && (
        <AppModalTemplate
          width={"700px"}
          isOpen={openRetireModal}
          setIsOpen={handleOpenRetireModal}
        >
          <RetirementFormModal
            isOpen={openRetireModal}
            isLoading={isLoading}
            setIsOpen={setOpenRetireModal}
            onValidate={handleOpenRetireModal}
            floatAdvanceData={data?.responseObject?.floatAdvance}
            vendorDocument={vendorDocument}
            setVendorDocument={setVendorDocument}
            promotionalItemsData={data?.responseObject?.promotionalItems}
            openSurveyModal={handleOpenSurveyModal}
          />
        </AppModalTemplate>
      )}
      {openSurveyModal && (
        <AppModalTemplate
          width={"700px"}
          isOpen={openSurveyModal}
          setIsOpen={handleOpenSurveyModal}
        >
          <SurveyModal
            handleSubmitSurvey={(formData, surveyData) =>
              handleSubmitSurvey(formData, surveyData, data)
            }
            isLoading={isLoading}
            setOpenSurveyModal={setOpenSurveyModal}
            categoryType={categoryType}
          />
        </AppModalTemplate>
      )}
    </PageLayout>
  );
};

export { ViewRetirement };
